<template>
  <app-loading-section class="tab-loading-section" :loading="isLoading">
    <stats-team-chart :chart-data="leads"/>
  </app-loading-section>
</template>

<script>
import StatsTeamChart from "./StatsTeamChart.vue";
import utils from "../../../services/utils";
import api from "../../../api";

export default {
  name: "StatsTeamLeadIntake",
  components: {
    StatsTeamChart,
  },
  data() {
    return {
      isLoading: true,
      leads: [],
      chartTemplate: {
        label: '',
        total: 0,
        chart: {
          labels: [],
          datasets: [{
            label: '',
            ids: [],
            data: [],
            backgroundColor: [],
            hoverOffset: 4,
            borderWidth: 4,
          }]
        }
      },
    }
  },
  watch: {
    'activeTab' () {
      if (this.activeTab === 'StatsTeamLeadIntake') {
        this.loadStats()
      }
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['statsTeam/getActiveTab']
    },
    statFilter() {
      return this.$store.getters['statsTeam/getFilters']
    },
    chartBgColors() {
      return this.$store.getters['statsTeam/getChartBackgroundColors']
    },
  },
  methods: {
    loadStats() {
      this.isLoading = true
      this.leads = []

      const data = {
        start_at: this.statFilter.timeFrameValues.start,
        end_at: this.statFilter.timeFrameValues.end,
        users: this.statFilter.users
      }

      Promise.all([
        api.statsTeam.getLeadsCreatedManually(data),
        api.statsTeam.getAssignedLeads(data),
        api.statsTeam.getAppointmentsSets(data)
      ]).then(([
        resLeadsCreatedManually,
        resAssignedLeads,
        resAppointmentsSets
      ]) => {
        this.leads.push(
          this.formatResponse('Leads Created', resLeadsCreatedManually.data),
          this.formatResponse('Assigned Leads', resAssignedLeads.data),
          this.formatResponse('Appointments Set', resAppointmentsSets.data)
        )
      })
      .finally(() => this.isLoading = false)
    },
    formatResponse(label, response) {
      let chartData = utils.clone(this.chartTemplate)

      chartData.label = label
      if (response.length === 0) return chartData

      chartData.total = response.reduce((accumulator, res) => accumulator + res.total, 0)
      if (chartData.total) {
        chartData.chart.labels = response.map(res => res.user_name)
        chartData.chart.datasets[0].label = label

        response.forEach(res => {
          chartData.chart.datasets[0].ids.push(res.user_id)
          chartData.chart.datasets[0].data.push(res.total)

          const bgColor = this.chartBgColors.find(color => color.userId === res.user_id)
          if (bgColor) {
            chartData.chart.datasets[0].backgroundColor.push(bgColor.color)
          }
        })
      }

      return chartData
    },
  },
}
</script>

<style scoped lang="scss">

</style>
